/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import type { HTMLAttributes } from 'react';
import cx from 'classnames';
import { Icon } from 'sarsaparilla';

import styles from './IconBadge.module.scss';

export type IconBadgeSize = 'md';

export type IconBadgeName = 'tent' | 'ticket' | 'card' | 'picnic-table' | 'tree' | 'pin';

export interface IconBadgeProps extends HTMLAttributes<HTMLDivElement> {
    iconName: IconBadgeName;
    size?: IconBadgeSize;
    hasInnerBg?: boolean;
}

export function IconBadge({
    iconName,
    size = 'md',
    hasInnerBg = true,
    className,
    ...rest
}: IconBadgeProps) {
    return (
        <div
            data-component="IconBadge"
            className={cx(styles.badge, styles[size], styles[iconName], className)}
            {...rest}
        >
            {hasInnerBg ? (
                <div className={styles.inner} aria-hidden="true">
                    <Icon iconName={iconName} />
                </div>
            ) : (
                <Icon iconName={iconName} />
            )}
        </div>
    );
}
